import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ConfirmedGraphic } from '../../../../design-system';

export const ChangePasswordComplete: React.FC = () => (
  <>
    <ConfirmedGraphic my={2} textAlign="center" svgProps={{ style: { maxWidth: '40%', height: '100%' } }} />
    <Box textAlign="center">
      <Typography>Your password has been successfully changed.</Typography>
    </Box>
    <Box mt={2} textAlign="center">
      <Button color="primary" variant="outlined" component={RouterLink} to="/user">
        Back to settings
      </Button>
    </Box>
  </>
);
